import { render, staticRenderFns } from "./translateForm.vue?vue&type=template&id=b8efb62e&scoped=true"
import script from "./translateForm.vue?vue&type=script&lang=js"
export * from "./translateForm.vue?vue&type=script&lang=js"
import style0 from "./translateForm.vue?vue&type=style&index=0&id=b8efb62e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8efb62e",
  null
  
)

export default component.exports